module.exports = __webpack_public_path__ + "img/google-stadia-02.addaf3cb.webp";